/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/328-move-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12 11V5h-1v6H8.5l3 3 3-3zM5 4v3H2V4h3zm1-1H1v5h5V3zM1 10h1.5v1H1v-1zM3 10h1.5v1H3v-1zM5 10h1v1.5H5V10zM1 13.5h1V15H1v-1.5zM2.5 14H4v1H2.5v-1zM4.5 14H6v1H4.5v-1zM1 11.5h1V13H1v-1.5zM5 12h1v1.5H5V12z"/>'
  }
})
